module.exports = __webpack_public_path__ + "img/wszzs_img.5db1df59.png";